module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido13.a3e4fe51.svg";